import React from 'react';
import { Link } from 'react-router-dom';

const CallToActionSection: React.FC = () => (
  <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-4">
        Ready to Transform Your Career?
      </h2>
      <p className="text-xl mb-8 text-blue-100">
        Join thousands of professionals who have advanced their careers with our SAP S4HANA training
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link
          to="/book-demo"
          className="bg-yellow-400 text-blue-900 px-8 py-3 rounded-lg font-semibold hover:bg-yellow-300 transition-colors"
        >
          Book Free Demo
        </Link>
        <Link
          to="/courses"
          className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-900 transition-colors"
        >
          View Courses
        </Link>
      </div>
    </div>
  </section>
);

export default CallToActionSection;
